import * as z from "zod";

export const deleteGuidance = {
  name: "deleteGuidance" as const,
  input: z.object({}),
  output: z.void(),
};
